import HostedPageHelper from "@/utils/hosted-page-helper"

export default class SubData {
  constructor(subscription) {
    this.subscription = subscription;
    this.id = subscription.id;
  }


  setRecurringEstimate(estimate) {
    this.recurringEstimate = estimate;
  }

  setGiftData(gift) {
    this.giftData = gift;
  }

  constructOrderItem() {
    // get plans and addons from recurring estimate and construct order item
    if(this.recurringEstimate) {
      return HostedPageHelper.constructOrderItemsFromEstimate(this.recurringEstimate, this.subscription);
    }
    else {
      return HostedPageHelper.constructOrderItemsFromSubscription(this.subscription);
    }
  }

  constructOrderItemsFromEstimate(estimate) {
    return HostedPageHelper.constructOrderItemsFromEstimate(estimate, this.subscription);
  }

  status() {
    return this.subscription.status;
  }

  billing_period() {
    return this.subscription.billing_period;
  }

  billing_period_unit() {
    return this.subscription.billing_period_unit;
  }

  planId() {
    return this.orderItem.plan.id;
  }

  payment_source_id() {
    return this.subscription.payment_source_id;
  }

  displayer() {
    return {
      plan_id: this.orderItem.plan.id,
      plan_trial_unit: this.orderItem.plan.details.trial_period_unit,
      plan_name: this.orderItem.plan.details.invoice_name || this.orderItem.plan.details.name,
      plan_quantity: this.orderItem.plan.quantity,
      description: this.orderItem.plan.details.description,
      addons: this.orderItem.addons,
      hide_plan: !this.orderItem.plan.lineItem,
      state: this.subscription.status,
      billing_period: this.subscription.billing_period,
      billing_period_unit: this.subscription.billing_period_unit,
      currency_code: this.subscription.currency_code,
      recurring_price: this.recurringEstimate ? this.recurringEstimate.total : 0,
      shipping_address: this.subscription.shipping_address,
      payment_source_id: this.subscription.payment_source_id,
      id: this.id,
      activate_at: this.subscription.activate_at,
      auto_collection: this.subscription.auto_collection,
      subscription: this.subscription,
      recurringEstimate: this.recurringEstimate,
      isScheduledForResume: this.subscription.status == "paused" && this.subscription.resume_date,
      isScheduledForPause: (["active", "non_renewing"].indexOf(this.subscription.status) != -1) && this.subscription.pause_date,
      gift_id: this.subscription.gift_id,
      gift_data: this.giftData,
      isGift: this.subscription.gift_id,
      isGiftClaimed : this.subscription.gift_id && this.giftData && this.giftData.status == "claimed",
      isPaidByParent(store) {
        return store.getters.customerHasRelatedPaymentOwner(this.subscription.customer_id) && (this.subscription.override_relationship != true) ;
      },
      isInvoicedToParent(store) {
        return store.getters.customerHasRelatedInvoiceOwner(this.subscription.customer_id) && (this.subscription.override_relationship != true);
      },
      getPaymentOwnerDisplayName(store) {
        return store.getters.getCustomerDisplayName(store.getters.getPayOwnerIdOfCustomer(this.subscription.customer_id));
      },

      isScheduledForCancellation(){
        return (["cancelled"].indexOf(this.state) == -1) && this.subscription.cancelled_at != undefined;
      },
      remainingTrialPeriod() {
        let seconds = this.subscription.trial_end - Math.round(Date.now() / 1000);
        return Math.round(seconds / (60 * 60 * 24));
      },
      scheduledResumptionDate() {
        return this.subscription.resume_date;
      },

      canShowEdit(store) {
        // check if change subscription is selected
        if(!store.getters.cancan.allow('change-subscription.action')){
          return false;
        }

        if(this.gift_id) {
          return false;
        }

        switch(this.state){
          case "active" :
            return store.getters.cancan.allow('change-subscription.allowed_status.active');
          case "non_renewing" :
            return store.getters.cancan.allow('change-subscription.allowed_status.non_renewing');
          case "in_trial" :
            return store.getters.cancan.allow('change-subscription.allowed_status.trial');
          default :
            return false
        }

        if(this.isScheduledForPause) {
          return false;
        }

        // check if scheduled for cancellation
        // if(this.isScheduledForCancellation()) {
        //   if(!store.getters.cancan.allow('change-subscription.action.change_now')) {
        //     return false;
        //   }

        //   if(this.subscription.activate_at) {
        //     let auto_collection = this.subscription.auto_collection ?
        //        this.subscription.auto_collection == "on" : store.state.customer.data.auto_collection == "on";
        //     if(!auto_collection) {
        //       return false;
        //     }
        //     if(auto_collection && store.getters.payment_method_list.length == 0) {
        //       return false;
        //     }
        //   }
        // }

        return true;
      },
      remainingDaysForCancellation() {
        if(this.subscription.cancelled_at) {
          let cancelDate = this.subscription.cancelled_at * 1000;
          return Math.ceil(Math.abs(cancelDate - Date.now()) / (1000 * 3600 * 24));
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/sub-data.js